import { render, staticRenderFns } from "./DataQuality.vue?vue&type=template&id=76fa07e6&scoped=true"
import script from "./DataQuality.vue?vue&type=script&lang=js"
export * from "./DataQuality.vue?vue&type=script&lang=js"
import style0 from "./DataQuality.vue?vue&type=style&index=0&id=76fa07e6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76fa07e6",
  null
  
)

export default component.exports